module.exports = __webpack_public_path__ + "static/media/240x400.bd12cdb7.png";